(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-bike-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__rbBvInit) return;
  window.__rbBvInit = true;

  function loadVideo(card) {
    if (!card || card.dataset.loaded === 'true') return;
    var src = card.getAttribute('data-video-src');
    if (!src) return;
    var media = card.querySelector('.rb-bv__media');
    if (!media) return;

    var v = document.createElement('video');
    v.src = src;
    v.controls = true;
    v.autoplay = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.preload = 'auto';
    v.className = 'rb-bv__video';

    media.innerHTML = '';
    media.appendChild(v);
    card.dataset.loaded = 'true';

    var p = v.play();
    if (p && typeof p.catch === 'function') { p.catch(function () {}); }
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.rb-bv__card');
    if (card && card.getAttribute('data-video-src')) loadVideo(card);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var card = e.target.closest('.rb-bv__card');
    if (!card || !card.getAttribute('data-video-src')) return;
    e.preventDefault();
    loadVideo(card);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
